(function () {
  var titleText = window.theme && window.theme.cookieBannerTitle;
  if (!titleText) return;

  function syncCookieBannerTitle() {
    var title = document.getElementById('shopify-pc__banner__body-title');
    if (!title || title.textContent === titleText) return;
    title.textContent = titleText;
  }

  syncCookieBannerTitle();

  if (typeof MutationObserver === 'undefined') return;

  var observer = new MutationObserver(syncCookieBannerTitle);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
